var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.choseFile}},[_vm._t("button"),_c('input',{ref:"excel",staticClass:"file-hide",attrs:{"id":_vm.id,"type":"file","accept":".xlsx, .xls, .csv"},on:{"change":_vm.handleFileChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }